export const CHANGE_UPSELL = 'CHANGE_UPSELL';

export const changePreviewUpsell = (upsell) => ({
    type: CHANGE_UPSELL,
    payload: upsell,
});
